export const MAX_UPLOAD_BILLS = 10

export const MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 25

export const ALLOWED_UPLOAD_FILE_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
]

// Query params determining whether the upload modal is opened.
export const NEW_BILL_QUERY_PARAM = 'new_bill'
export const NEW_BILL_QUERY_VALUE = 'true'
